const formatDuration = (seconds: number): string => {
  const ONE_DAY_IN_SECONDS = 24 * 3600;

  // Above 1 day: d days h hours
  if (seconds > ONE_DAY_IN_SECONDS) {
    const days = Math.floor(seconds / ONE_DAY_IN_SECONDS);
    const remainingAfterDays = seconds % ONE_DAY_IN_SECONDS;
    const hours = Math.floor(remainingAfterDays / 3600);

    const daysStr = days > 1 ? 'days' : 'day';
    if (hours === 0) {
      return `${days} ${daysStr}`;
    }

    const hoursStr = hours > 1 ? 'hours' : 'hour';
    return `${days} ${daysStr} ${hours} ${hoursStr}`;
  }

  // Above 2 hours: h hours
  if (seconds >= 7200) {
    const hours = Math.floor(seconds / 3600);
    return `${hours} hours`;
  }

  // Below 2 hours: hh:mm:ss
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const hoursStr = hours > 0 ? `${hours}:` : ''; // Include hours only if non-zero
  const minutesStr = `${hours > 0 ? String(minutes).padStart(2, '0') : minutes}:`;
  const secondsStr = String(remainingSeconds).padStart(2, '0');

  return `${hoursStr}${minutesStr}${secondsStr}`;
};

export default formatDuration;
